enum UserRole {
  FOCAL_POINT = "ROLE_FOCAL_POINT",
  UNICC = "ROLE_UNICC",
  SUPPORT_TEAM = "ROLE_SUPPORT_TEAM",
  ADMIN = "ROLE_ADMIN"
}

export default UserRole
